"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var OrgEntitlementDetails = /*#__PURE__*/function () {
  OrgEntitlementDetails.$inject = ["entitlementsService"];
  /* @ngInject */
  function OrgEntitlementDetails(entitlementsService) {
    _classCallCheck(this, OrgEntitlementDetails);
    this.entitlementsService = entitlementsService;
  }
  _createClass(OrgEntitlementDetails, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var _this$entitlement = this.entitlement,
        type = _this$entitlement.type,
        id = _this$entitlement.id,
        parentEntitlementId = _this$entitlement.parentEntitlementId;

      // entitlement provided can be used directly, or details can be fetch
      if (!this.fetch) {
        this.entitlementDetails = this.entitlement;
        return;
      }

      // tag a entitlement where we retrieve the parent to get details, but is expired
      var isExpired = this.isExpired = type === this.entitlementsService.TYPE_EXPIRED || type === this.entitlementsService.TYPE_EXPIRED_EVENT;

      // for experired, retrieve parent entitlement as it's more relevant
      var retrievedId = isExpired ? parentEntitlementId : id;

      // retrieve entitlement details
      this.loading = true;
      this.entitlementsService.getEntitlement(this.organization._id, retrievedId).then(function (entitlement) {
        return _this.entitlementDetails = entitlement;
      }).finally(function () {
        return _this.loading = false;
      });
    }
  }]);
  return OrgEntitlementDetails;
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlement-details', ['backstage.services']).component('bsOrgEntitlementDetails', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlement-details/org-entitlement-details.html',
  bindings: {
    entitlement: '<',
    organization: '<',
    fetch: '@'
  },
  controller: OrgEntitlementDetails
}).name;